import type { ExecutionFilters } from '@/types/domain'
import { api, guard, unwrap } from './client'

export const executionsApi = {
  /** How many of this user's tool calls have happened since they last looked. */
  unseen: () => guard(async () => unwrap(await api.GET('/api/executions/unseen', {}))),

  /** Mark them read. A watermark moves; no execution is removed. */
  markSeen: () => guard(async () => unwrap(await api.POST('/api/executions/seen', {}))),

  list: (filters: ExecutionFilters) =>
    guard(async () =>
      unwrap(
        await api.GET('/api/executions', {
          params: {
            query: {
              tool: filters.tool,
              status: filters.status,
              risk: filters.risk,
              error_type: filters.error_type,
              repository: filters.repository,
              limit: filters.limit,
              offset: filters.offset,
            },
          },
        }),
      ),
    ),

  detail: (requestId: string) =>
    guard(async () =>
      unwrap(
        await api.GET('/api/executions/{request_id}', {
          params: { path: { request_id: requestId } },
        }),
      ),
    ),
}
